import { render, staticRenderFns } from "./StudyPlanTable.vue?vue&type=template&id=515f9f4a&scoped=true&"
import script from "./StudyPlanTable.vue?vue&type=script&lang=js&"
export * from "./StudyPlanTable.vue?vue&type=script&lang=js&"
import style0 from "./StudyPlanTable.vue?vue&type=style&index=0&id=515f9f4a&scoped=true&lang=scss&"
import style1 from "./StudyPlanTable.vue?vue&type=style&index=1&id=515f9f4a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "515f9f4a",
  null
  
)

export default component.exports